import { Theme } from '@mui/material/styles'

const muiBottonGroup = (theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        boxShadow: 'none',
        background: theme.palette.background.default,
        borderRadius: 12
      },
      grouped: {
        background: theme.palette.background.default,
        color: theme.colors.disabled,
        borderColor: theme.palette.background.default,
        border: 'none',
        minWidth: 120,
        '&.active': {
          background: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          borderRadius: 12
        },
        '&:hover': {
          border: 'none'
        },
        '&:not(:first-of-type)': {
          marginLeft: 0
        }
      }
    }
  }
}

export default muiBottonGroup
